export default __webpack_public_path__ + "static/travis@2x-9d7b142c7be6456ae42c3548385160f8.jpg";